(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Je zoekopdracht',
    noCollectionFound: 'Geen collecties gevonden',
    allProducts: 'producten',
    matching: 'gevonden voor',
    sortBy: 'Sorteren op',
    filterTile: 'Filteropties',
    relevance: 'Meest relevant',
    outOf: 'van',
    resultsFound: 'resultaten gevonden',
    oneResultFound: '1 resultaat gevonden',
    noResultFound: 'Geen resultaten gevonden',
    addToCart: 'Toevoegen aan winkelwagen',
    searchForProduct: 'Producten zoeken',
    selectedFilter: 'Geselecteerde filters',
    clearAll: 'Alles wissen',
    noPageFound: 'Geen pagina gevonden',
    outOfStock: 'Niet voorradig',
    seeAllResults: 'Alle zoekresultaten',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Geen resultaten voor ' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
